import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { createApi } from '@/features/utils';
import { CityItemType, DealerItemType } from '@/interfaces/dealers.interfaces';
import { DataTypeEnum } from '@/interfaces/settings.interfaces';
import { IGrpcService } from '@/services/GrpcService';
import injectContainer from '@/services/InjectContainer';
import ServiceTypes from '@/services/ServiceTypes';

import type { CityParametersType, DealerCenterParametersType } from './types';

export const dealersApi = createApi({
  reducerPath: 'dealers',
  baseQuery: fetchBaseQuery(),
  endpoints: builder => ({
    getDealerCenter: builder.query<DealerItemType | null, DealerCenterParametersType>({
      queryFn: async (parameters, api) => {
        const state = api.getState() as any;

        const { formatter } = state.config;

        const grpcService = injectContainer.get<IGrpcService>(ServiceTypes.Grpc);

        const { itemsClient } = grpcService;

        const { item } = await itemsClient.getPublished({
          ...parameters,
        });

        if (!item) {
          return {
            data: null,
          };
        }

        const dealerItem = (formatter?.(DataTypeEnum.DealerCenter, item) ||
          item) as DealerItemType;

        return { data: dealerItem };
      },
    }),
    getCity: builder.query<CityItemType | null, CityParametersType>({
      queryFn: async (parameters, api) => {
        const state = api.getState() as any;

        const { formatter } = state.config;

        const grpcService = injectContainer.get<IGrpcService>(ServiceTypes.Grpc);

        const { itemsClient } = grpcService;

        const { item } = await itemsClient.getPublished({
          ...parameters,
        });

        if (!item) {
          return {
            data: null,
          };
        }

        const cityItem = (formatter?.(DataTypeEnum.City, item) || item) as CityItemType;

        return { data: cityItem };
      },
    }),
  }),
});

const dealersReducer = dealersApi.reducer;

export default dealersReducer;
